import { createMutationHook } from '~/shared/providers/api';

type SelectOrganizationInput = {
  clientId: string;
  pendingAuthenticationToken: string;
  organizationId: string;
};

export const useSelectOrganization = createMutationHook(
  'authentication.selectOrganization',
  ({
    clientId,
    pendingAuthenticationToken,
    organizationId,
  }: SelectOrganizationInput) => ({
    authenticationSelectOrganization: {
      __args: {
        clientId,
        pendingAuthenticationToken,
        organizationId,
      },
      __typename: true,
      on_EmailVerificationRequiredError: {
        pendingAuthenticationToken: true,
      },
      on_MfaEnrollmentRequiredError: {
        pendingAuthenticationToken: true,
      },
      on_MfaChallengeError: {
        pendingAuthenticationToken: true,
        authenticationFactors: {
          __scalar: true,
        },
      },
      on_OrganizationSelectionError: {
        pendingAuthenticationToken: true,
        organizations: {
          id: true,
          name: true,
        },
      },
      on_AuthenticationResponse: {
        accessToken: true,
        user: {
          id: true,
          firstName: true,
          lastName: true,
          email: true,
        },
        organization: {
          id: true,
          name: true,
          domain: true,
          entitlements: true,
        },
      },
    },
  }),
);
